

































import {Component, Prop, Vue} from 'vue-property-decorator'
import App from '@/components/app/app';

@Component
export default class SearchSettingsComponent extends Vue
{
    @Prop({required: true}) settings: SearchSettings;
    // TODO: Show all courses option
}

export class SearchSettings
{
    showAllCourses: boolean = App.instance.user.gradeLevel == 12;
    sortBy: string = 'Name'
    levels: string[] = ['AP','H','A','CP']
}
